var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.097.111a.38.38 0 0 1 .538 0l.854.854a.38.38 0 0 1 0 .538L8.19 6.8l5.298 5.297c.13.13.146.33.048.478l-.048.06-.854.854a.38.38 0 0 1-.538 0L6.8 8.19l-5.297 5.298a.38.38 0 0 1-.478.048l-.06-.048-.854-.854a.38.38 0 0 1 0-.538L5.41 6.8.111 1.503a.38.38 0 0 1-.048-.478L.11.965.966.112a.38.38 0 0 1 .537 0L6.8 5.41Z"
})));
export default SvgTiktokDesktopClose;